import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../legacy/hui/src/styled/theme';
import { ErrorText } from '../Field';
import { Field } from 'redux-form';

const StyledField = styled(Field)`
  width: 100%;
  font-size: 16px;
  border: 0;
  border-radius: 4px;
  margin-top: 8px;
  appearance: none;
  outline: 0;
  border: 1px solid ${colors.GREY};
  position: relative;
  padding: 11px 20px;
`;

const StyledLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
`;

export default function TextArea({ name, label, placeholder, input, meta, ...rest }) {
  const { isRequired, ...htmlAttr } = rest; // eslint-disable-line no-unused-vars
  return (
    <StyledLabel>
      <span>{label}</span>
      <StyledField
        name={name}
        component="textarea"
        {...input}
        {...htmlAttr}
        rows="4"
        placeholder={placeholder}
      />
      {!!meta && meta.error && <ErrorText>{meta.error}</ErrorText>}
    </StyledLabel>
  );
}

TextArea.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};
